import { render, staticRenderFns } from "./home_2.vue?vue&type=template&id=00e40e78"
import script from "./home_2.vue?vue&type=script&lang=js"
export * from "./home_2.vue?vue&type=script&lang=js"
import style1 from "./home_2.vue?vue&type=style&index=1&id=00e40e78&prod&lang=less&scope=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports